import React from 'react';

// Single stroke-based icon set. 1.75 stroke weight reads well at 16-20px on
// dark surfaces without turning bold.
function Icon({ size = 18, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const SearchIcon = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Icon>
);

export const CloseIcon = (props) => (
  <Icon {...props}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Icon>
);

export const SlidersIcon = (props) => (
  <Icon {...props}>
    <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h10M18 18h2" />
    <circle cx="16" cy="6" r="2" />
    <circle cx="10" cy="12" r="2" />
    <circle cx="16" cy="18" r="2" />
  </Icon>
);

export const SortIcon = (props) => (
  <Icon {...props}>
    <path d="M4 7h11M4 12h7M4 17h4" />
    <path d="M17 10v9M17 19l3-3M17 19l-3-3" />
  </Icon>
);

export const CheckIcon = (props) => (
  <Icon {...props}>
    <path d="m5 12 5 5L19 7" />
  </Icon>
);

export const ArrowLeftIcon = (props) => (
  <Icon {...props}>
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </Icon>
);

export const PinIcon = (props) => (
  <Icon {...props}>
    <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" />
    <circle cx="12" cy="10" r="2.5" />
  </Icon>
);

export const CalendarIcon = (props) => (
  <Icon {...props}>
    <rect x="3" y="5" width="18" height="16" rx="2.5" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </Icon>
);

export const TicketIcon = (props) => (
  <Icon {...props}>
    <path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8Z" />
    <path d="M13 6v2M13 11v2M13 16v2" />
  </Icon>
);

export const ShareIcon = (props) => (
  <Icon {...props}>
    <path d="M12 3v13M12 3 8 7M12 3l4 4" />
    <path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
  </Icon>
);

// Outline by default; `filled` paints it in for the saved state.
export const HeartIcon = ({ filled = false, ...props }) => (
  <Icon {...props}>
    <path
      d="M12 20.3s-7.4-4.6-7.4-9.6A4.3 4.3 0 0 1 12 7.9a4.3 4.3 0 0 1 7.4 2.8c0 5-7.4 9.6-7.4 9.6Z"
      fill={filled ? 'currentColor' : 'none'}
    />
  </Icon>
);

export const ArrowUpIcon = (props) => (
  <Icon {...props}>
    <path d="M12 20V5M6 11l6-6 6 6" />
  </Icon>
);

export const SearchOffIcon = (props) => (
  <Icon size={26} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5M8.5 11h5" />
  </Icon>
);

export const InfoIcon = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5M12 7.5v.5" />
  </Icon>
);

export const AlertIcon = (props) => (
  <Icon size={26} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v6M12 16.5v.5" />
  </Icon>
);

// Brand mark: a map pin whose centre is a spark of activity.
export const BrandMark = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 22s7-6 7-11.5A7 7 0 0 0 5 10.5C5 16 12 22 12 22Z"
      fill="currentColor"
      opacity="0.25"
    />
    <path
      d="M12 3.5a7 7 0 0 1 7 7C19 16 12 22 12 22S5 16 5 10.5a7 7 0 0 1 7-7Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.8 13.3 9.5l2.9.3-2.2 2 .6 2.9-2.6-1.5-2.6 1.5.6-2.9-2.2-2 2.9-.3L12 6.8Z"
      fill="currentColor"
    />
  </svg>
);

export default Icon;
